module.exports = __webpack_public_path__ + "fonts/comfortaa-v27-latin-700.863cae85.woff2";